// extracted by mini-css-extract-plugin
export default {"form-content":"CarouselForm_form-content__zIW1u","imageCont":"CarouselForm_imageCont__kOxpJ","image":"CarouselForm_image__iwcil","content-image":"CarouselForm_content-image__2Hif3"};